module.exports = __webpack_public_path__ + "static/img/人员聚集监测.f772997e.png";